module.exports = {
    proxyUrl: 'yalp.test',
    port: 3000,
};

